<script setup>
    import {computed} from "vue";

    const props = defineProps({
        locale: String
    })

    const flagCode = computed(() => {
        const code = props.locale.toLowerCase();
        if (code === 'en') return 'gb';
        if (code === 'cs') return 'cz';
        if (code === 'uk') return 'ua';
        return code;
    })
</script>

<template>
    <span class="fi" :class="`fi-${flagCode}`"></span>
</template>
